import { GlobalController } from 'src/shared/global/GlobalController'
import Address from './Address'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'address',
    component: Address,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
